<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- <el-button type="primary" @click="getfanyi">导出</el-button> -->
  </div>
</template>

<script>

import language from './utlis/language2'
// token 统一工具：session 优先于 local
import { hasToken, removeToken, clearAllToken } from './utlis/token'
export default {
  data() {
    return {}
  },
  components: {},
  mounted() {
    window.addEventListener('load', () => {
      //写入你想要执行的代码
      if (
        this.$store.state.searchInfo !== '' &&
        this.$route.name !== 'CommoditySearch'
      ) {
        this.$store.state.searchInfo = ''
      }
    })
  },

  watch: {
    $route(to, from) {
      if (
        this.$store.state.searchInfo !== '' &&
        to.path !== '/commoditySearch'
      ) {
        this.$store.state.searchInfo = ''
      }
    },
  },
  created() {
    window.addEventListener('storage', this.handleStorageChange);
    // document.querySelector('#cnzz_stat_icon_1281191904').style.position = 'fixed';
    // document.querySelector('#cnzz_stat_icon_1281191904').style.bottom = '0'
    if (this.$store.state.goodsList.length == 1) {
      this.$api
        .getShopGroup(this.form)
        .then((result) => {
          this.lists = result.data
          this.$store.commit('getgoodsList', result.data)
          this.allListShow()
        })
        .catch((err) => { })
    }
    // 预加载登录页面图片
    let image = new Image()

    image.src = require('./assets/login/bg.png')

    this.commonExchangeRate()
    // 有 token 则处理用户信息；读取时 sessionStorage 优先于 localStorage
    if (hasToken()) {
      // userInfo 为空时由路由守卫拉取并等待，避免和守卫同时失败把后台 session 清掉
      if (!this.$store.state.userInfo) {
        return
      }
      this.$api.EuropegetUserInfo().then((res) => {
        // 登录失效：清当前生效 token；若只是临时 session 失效，可回退本地登录
        if (res.code != 0) {
          this.$store.commit('userData', null)
          removeToken()
          if (hasToken()) {
            // session 失效后本地仍有正式 token，再拉一次用户信息
            this.$api.EuropegetUserInfo().then((localRes) => {
              if (localRes.code == 0) {
                this.$store.commit('userData', localRes.data)
              } else {
                clearAllToken()
                let requireAuth = this.$route.matched[0] && this.$route.matched[0].meta.requireAuth
                if (requireAuth) {
                  this.$fun.toPage('/')
                }
              }
            })
            return
          }
          // 有需要验证的用户中心
          let requireAuth = this.$route.matched[0] && this.$route.matched[0].meta.requireAuth
          if (requireAuth) {
            this.$fun.toPage('/')
          }
          return
        } else {
          return this.$store.commit('userData', res.data) // 用户信息存储
        }
      })
    } else {
      // 无 token：清空用户信息。地址栏若还带着后台 token，不要清存储，等守卫写入 session
      this.$store.commit('userData', null)
      if (!(this.$route.query && this.$route.query.user_token)) {
        clearAllToken()
      }
    }
  },
  methods: {
    fanyi() {
      localStorage.removeItem('fanyi')
      this.$forceUpdate()
    },
    handleStorageChange() {

    },
    commonExchangeRate() {
      // 获取汇率
      this.$api.commonExchangeRate().then((res) => {
        this.$store.commit('getexchangeRate', res.data)
      })
    },
    getfanyi() {
      
      let list = []
      language.forEach((item) => {
        if (item.key == item.value) {
          list.push(item)
        }
      })
      require.ensure([], () => {
        const { export_json_to_excel } = require('@/utlis/Export2Excel')
        const tHeader = ['中文', '英文翻译']
        const filterVal = ['key']

        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '美国站待翻译')
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
  },
  
  mounted() {





  }
}
</script>
<style lang="scss">
@import './css/mixin';

/deep/.el-dialog__wrapper {
  .el-dialog {
    border-radius: 6px !important;
  }
}

html,
body,
#app {
  height: 100%;
  font-family: 'Roboto-Regular, Roboto';
}

/deep/ .el-input__inner {
  font-family: 'Roboto-Regular, Roboto';
  color: pink !important;
}

* {
  box-sizing: border-box;
}

a {
  cursor: pointer;

}

.poinDone {
  pointer-events: none;

  &*,
  *,
  *::before {
    pointer-events: none;
  }
}

input[type='checkbox'] {
  $checkBoxSize: 20px;

  width: $checkBoxSize;
  height: $checkBoxSize;
  border-radius: 50%;
  border: 1px solid #888888;
  background-color: white;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &:checked {
    background: #ff730b;
    border: none;
  }

  &:checked::after {
    content: '';

    background: transparent;
    border: #fff solid 1.5px;
    border-top: none;
    border-right: none;
    height: 2px;
    width: 40%;
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg) translate(1px, -1px);
  }
}

button {
  cursor: pointer;
  transition: 0.3s;
  background-color: transparent;
}

.anniu {
  border: solid;
  position: fixed;
  width: 100px;
  height: 100px;
  left: 0px;
  z-index: 55999999;
}

// 去除弹出框背景颜色等
.el-popover.el-popper.notHaveBackground {
  background-color: transparent;
  box-shadow: none;
  border: none;
  margin-top: 0;
  padding: 0;

  .popper__arrow {
    display: none;
  }
}

// 禁用状态下的组件字体颜色
.is-disabled .el-input__inner {
  color: #666666;
}
</style>
<style>
#cnzz_stat_icon_1281134212 {
  opacity: 0;
  height: 0;

}
</style>
